export const TrackingEvents = {
  LOGIN: {
    login_user_loggedin: 'login_user_loggedin',
    login_user_session_ended: 'login_user_session_ended',
  },
  MENU: {
    menu_item_accessed: 'menu_item_accessed',
  },
  TOKEN_REDIRECT: {
    factorygpt_report_link_clicked_email: 'factorygpt_report_link_clicked_email',
  },
};

export enum SessionEndType {
  AUTOMATIC = 'automatic_close',
  USER_LOGOUT = 'user_logout',
  ACCOUNT_SWITCH = 'account_switch'
}
